<template>
    <div>
        <v-dialog v-model="dialog" persistent width="500">
            <v-card>
                <v-toolbar color="primary" dark flat dense cad>
                    <v-toolbar-title class="subheading">Pencairan Modal Kerja</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="closedialog">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="text-xs-left">
                    <v-form ref="form" lazy-validation>
                        <v-col cols="12" md="12 ">
                            <v-text-field label="Jumlah" clearable name="name" v-model="amount"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="12 ">
                            <v-text-field label="Biaya" readonly name="name" reverse v-model="biaya"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="12" class="text-end">
                            <v-text-field class="right-input align-content-end" reverse label="Total Pembayaran" name="name" v-model="totalcair"></v-text-field>
                        </v-col>
                    </v-form>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text dark @click="closedialog" color="red">Tutup</v-btn>
                    <v-btn text dark @click="cairkan" :loading="loading" color="green">Cairkan</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-layout row wrap>
            <v-flex lg4 sm6 xs12>
                <v-card class="ma-3" elevation="0" style="border: thin solid rgba(0,0,0,.12)">
                    <v-list-item>
                        <v-sheet class="mt-n12" color="green" width="50" height="50" elevation="1">
                            <v-icon dark large class="icondash">account_balance_wallet</v-icon>
                        </v-sheet>
                        <v-list-item-content>
                            <div class="text-right mb-2">Sisa Limit Kredit</div>
                            <v-list-item-title class="headline mb-1 text-right">{{formatAngka(loan.creditlimit-loan.used)}}
                            </v-list-item-title>
                            <div>
                                <v-progress-linear v-if="loan.progress>60"
                                        color="green"
                                        height="5"
                                       stream
                                        v-model="loan.progress"
                                ></v-progress-linear>
                                <v-progress-linear v-if="loan.progress<60"
                                        color="deep-orange"
                                        height="5"
                                        v-model="loan.progress"
                                ></v-progress-linear>
                                <v-progress-linear v-if="loan.progress<30"
                                        color="red"
                                        height="5"
                                        v-model="loan.progress"
                                ></v-progress-linear>
                            </div>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-card-actions>
<!--                        <div class="ml-4">-->
<!--                            <v-flex row wrap>-->
<!--                                <v-flex lg12 sm6 xs12>-->
<!--                                    <h4> Pemakaian: {{formatAngka(1000000)}}</h4>-->
<!--                                </v-flex>-->
<!--                                <v-flex lg12 sm6 xs12>-->
<!--                                    <h4> Jatuh Tempo: 2020-09-18</h4>-->
<!--                                </v-flex>-->
<!--                            </v-flex>-->
<!--                        </div>-->

                        <v-spacer/>
                        <v-btn  dark depressed @click="openform" color="green">Cairkan</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>

        <v-tabs  v-model="tab">
            <v-tab>Pencairan</v-tab>
            <v-tab>Pembayaran</v-tab>
            <v-tab-item>
                <ListPencairan/>
            </v-tab-item>
            <v-tab-item>
                <ListPembayaran/>
            </v-tab-item>
        </v-tabs>
    </div>
</template>

<script>
    import {mapActions, mapState} from "vuex";
    import Utils from "@/plugins/utils";
    import ListPencairan from "@/components/irmacapital/ListPencairan";
    import ListPembayaran from "@/components/irmacapital/ListPembayaran";

    export default {
        name: "dashboardcapital",
        components: {ListPembayaran, ListPencairan},
        data: ()=>({
            tab: null,
            amount:0,
            biaya: 0,
            totalcair: 0
        }),
        watch: {
            amount (n) {
                var a =n*this.setting.fee
                this.biaya = this.formatAngka(a)
                this.totalcair=this.formatAngka(parseInt(n)+a)
            }
        },
        computed: {
            ...mapState('Loan',['loading','loan','contract','dialog','setting'])
        },
        methods: {
            ...mapActions('Loan',['getLoan','opendialog','closedialog','doCreateContract']),
            formatAngka(val){
                return Utils.formatAngka(val)
            },
            openform (){
                this.amount=0
                this.opendialog();
            },
            cairkan(){
                this.doCreateContract({amount:this.amount});
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .caro {
        height: 265px;
    }
    .icondash {
        margin-left: 6px;
        margin-top 5px;
    }
</style>
